import 'leaflet/dist/leaflet.css';
import React, { useState } from 'react';
import { MapContainer, TileLayer, CircleMarker, Popup } from 'react-leaflet';
import { useTheme } from '@mui/material';
import { Box } from '@mui/material';

export const UserLocationMap = ({ data = [] }) => {
    const theme = useTheme();
    const mode = theme.palette.mode;

    // Choose tile layer based on theme
    const tileLayerUrl =
        mode === "dark"
            ? "https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png"
            : "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png";
    const tileLayerAttribution =
        mode === "dark"
            ? '&copy; <a href="https://carto.com/">CARTO</a>'
            : '&copy; <a href="https://osm.org/copyright">OpenStreetMap</a> contributors';

    return (
        <Box 
            sx={{ 
                position: 'relative', 
                height: '100%', 
                width: '100%',
                minHeight: '400px',
                borderRadius: 2,
                overflow: 'hidden',
                '& .leaflet-popup-content-wrapper': {
                    backgroundColor: theme.palette.background.paper,
                    color: theme.palette.text.primary,
                },
                '& .leaflet-popup-tip': {
                    backgroundColor: theme.palette.background.paper,
                }
            }}
        >
            <MapContainer
                center={[20, 0]}
                zoom={2}
                style={{ height: '100%', width: '100%', minHeight: '400px' }}
                scrollWheelZoom={false}
            >
                <TileLayer
                    url={tileLayerUrl}
                    attribution={tileLayerAttribution}
                />

                {data.map((loc, idx) => (
                    loc.lat && loc.lng ? (
                        <CircleMarker
                            key={idx}
                            center={[loc.lat, loc.lng]}
                            radius={4 + (Math.log(loc.count || 1) * 2)}
                            pathOptions={{
                                color: theme.palette.primary.main,
                                fillColor: theme.palette.primary.main,
                                fillOpacity: 0.6,
                                weight: 1
                            }}
                        >
                            <Popup>
                                <div style={{ textAlign: 'center' }}>
                                    <strong>{loc.name}</strong><br />
                                    {loc.count} Users
                                </div>
                            </Popup>
                        </CircleMarker>
                    ) : null
                ))}
            </MapContainer>
        </Box>
    );
};
